import * as React from 'react';
import { Button, SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

interface EmptyStateProps {
  title: string;
  description: string;
  confirmationText?: string;
  onConfirmClick?: React.MouseEventHandler;
}

export function EmptyState({ title, description, confirmationText, onConfirmClick }: EmptyStateProps) {
  return (
    <Wrapper direction="y" spacing="" padding={tk('spacing_md')} alignItems="center" justifyContent="center">
      <Typography as="p" $variant="body-lg-bold">
        {title}
      </Typography>
      <Typography as="p">{description}</Typography>
      {confirmationText && (
        <Button $withoutColor onClick={onConfirmClick}>
          {confirmationText}
        </Button>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(SpaceBetween)`
  flex: 1;

  ${Button} {
    margin-top: ${tk('spacing_xl')};
  }
`;
